module.exports = fox._r("images/promo/tutor-girl.jpg", __webpack_public_path__ + "_/common/images/promo/tutor-girl.jpg");


//////////////////
// WEBPACK FOOTER
// ../common/images/promo/tutor-girl.jpg
// module id = 44
// module chunks = 2